module.exports = __webpack_public_path__ + "img/lobster.9975b708.png";